import {
  ArchiveTradingAccountsByNamesDto,
  ArchiveTradingAccountsResponseDto,
} from '@/api/Trading-Accounts/Types/ArchiveTradingAccountsDto'
import {
  RewardProgramDetailsDto,
  RewardProgramDetailsUpdateDto,
} from '@/api/Trading-Accounts/Types/RewardProgramDto'
import {
  RewardProgramDto,
  RewardsHubCreateDto,
  RewardsHubDto,
} from '@/api/Trading-Accounts/Types/RewardsHubDto'
import { RunDividendAdjustmentsDto } from '@/api/Trading-Accounts/Types/RunDividendAdjustmentsDto'
import { UpdateTradingAccountArchivingExclusionDto } from '@/api/Trading-Accounts/Types/UpdateTradingAccountDto'
import { MarginBonusLabel } from '@/api/Wallet/Types/BonusCampaignTypes'
import { AddEditSwapFreeOptionFormValues } from '@/routes/Brokerage/SwapFreeRating/AddEditSwapFreeOptionForm'
import { AuditLog } from 'api/Clients/Types/AuditLog'
import {
  ClientPlatformLimitDto,
  UpdateClientPlatformLimitDto,
} from 'api/Clients/Types/ClientDetailedDto'
import { ClientPlatformType } from 'api/Clients/Types/ClientPlatformType'
import { CountryPreferenceDto } from 'api/Clients/Types/CountryPreference'
import { DemoAccountDetails, UpdateDemoTradingAccount } from 'api/Clients/Types/DemoAccountDetails'
import { RoleSecuredProperties } from 'api/Clients/Types/RoleSecuredProperties'
import { SecuredPropertiesLabels } from 'api/Clients/Types/SecuredPropertiesLabels'
import { SwapFreeOptionDto } from 'api/Clients/Types/SwapFreeOptionDto'
import { TradingAccountDto } from 'api/Clients/Types/TradingAccount'
import { TradingAccountDetailDto } from 'api/Clients/Types/TradingAccountDetails'
import { TradingAccountOpenPositionsDto } from 'api/Clients/Types/TradingAccountOpenPositionsDto'
import { TradingAccountPendingOrderDto } from 'api/Clients/Types/TradingAccountPendingOrderDto'
import { UpdateTradingAccount } from 'api/Clients/Types/UpdateTradingAccount'
import {
  UpdateWelcomeTradingAccount,
  WelcomeAccountDetails,
} from 'api/Clients/Types/WelcomeAccountDetails'
import { NameDto } from 'api/Common/Types'
import { PageData } from 'api/Pagination/Types'
import { PlatformDownloadLinkDto } from 'api/Trading-Accounts/PlatformLink.Dto'
import { AccountGroupBasicDto, AccountGroupDto } from 'api/Trading-Accounts/Types/AccountGroupDto'
import { AddUpdateInstrument } from 'api/Trading-Accounts/Types/AddUpdateInstrument'
import { BookType } from 'api/Trading-Accounts/Types/BookType'
import { CreateIBProfileInstrument } from 'api/Trading-Accounts/Types/CreateIBProfileInstrument'
import { CreateSubscriptionDetail } from 'api/Trading-Accounts/Types/CreateSubscriptionDetail'
import { CreateSubscriptionPlatform } from 'api/Trading-Accounts/Types/CreateSubscriptionPlatform'
import { CreateTradingAccount } from 'api/Trading-Accounts/Types/CreateTradingAccount'
import {
  DividendPaymentDataDto,
  UpdateDividendPaymentDataDto,
  UploadDividendPaymentDataDto,
} from 'api/Trading-Accounts/Types/DividendsDto'
import { EditSubscription } from 'api/Trading-Accounts/Types/EditSubscription'
import { EditSubscriptionDetail } from 'api/Trading-Accounts/Types/EditSubscriptionDetail'
import {
  InstrumentDto,
  LeverageInstrumentDto,
  UploadLeverageInstrumentDto,
} from 'api/Trading-Accounts/Types/InstrumentDto'
import { AccountGroup } from 'api/Trading-Accounts/Types/IntroducingBrokerDetailedProfileDto'
import { IntroducingBrokerProfileAccountType } from 'api/Trading-Accounts/Types/IntroducingBrokerProfileAccountType'
import { LeverageType } from 'api/Trading-Accounts/Types/LeverageType'
import { MarketingCampaignDetailDto } from 'api/Trading-Accounts/Types/MarketingCampaignDetailDto'
import { MarketingCampaignDto } from 'api/Trading-Accounts/Types/MarketingCampaignDto'
import {
  InternalResultsIBResultsDto,
  LuckyDrawActivityTypeDto,
  LuckyDrawResultDto,
  LuckyDrawRewardsDto,
  LuckyDrawRewardTypeDto,
  MarginBonusResultDto,
} from 'api/Trading-Accounts/Types/MarketingCampaignResultsDto'
import {
  getCampaignName,
  MarketingCampaignType,
} from 'api/Trading-Accounts/Types/MarketingCampaignType'
import { PlatformStatisticsDto } from 'api/Trading-Accounts/Types/PlatformStatisticsDto'
import { PlatformTransactionDto } from 'api/Trading-Accounts/Types/PlatformTransactionDto'
import { PlatformTransactionTypeDto } from 'api/Trading-Accounts/Types/PlatformTransactionTypeDto'
import { PlatformTypeDto, PlatformTypeId } from 'api/Trading-Accounts/Types/PlatformTypeDto'
import { ResetTradingAccountPassword } from 'api/Trading-Accounts/Types/ResetTradingAccountPassword'
import { ServerType } from 'api/Trading-Accounts/Types/ServerType'
import { SubscriptionDetailDetailsDto } from 'api/Trading-Accounts/Types/SubscriptionDetailDetailsDto'
import {
  SubscriptionDetailDto,
  SubscriptionDetailsDto,
} from 'api/Trading-Accounts/Types/SubscriptionDetailsDto'
import { SubscriptionGroupDto } from 'api/Trading-Accounts/Types/SubscriptionGroupDto'
import { TradingAccountActivityDetailsDto } from 'api/Trading-Accounts/Types/TradingAccountActivityDetailsDto'
import { TradingAccountActivityDto } from 'api/Trading-Accounts/Types/TradingAccountActivityDto'
import { TradingAccountCountryDto } from 'api/Trading-Accounts/Types/TradingAccountCountryDto'
import { TradingAccountLotsProfitStatisticDto } from 'api/Trading-Accounts/Types/TradingAccountLotsProfitStatisticDto'
import {
  TradingViewPlanDto,
  TradingViewPlanExpirationDaysDto,
} from 'api/Trading-Accounts/Types/TradingViewPlanDto'
import {
  EditUnsubscribeRequestDto,
  EditUnsubscribeRequestsDto,
  UnsubscribeRequestDto,
} from 'api/Trading-Accounts/Types/UnsubscribeRequestDto'
import { UpdateAccountGroup } from 'api/Trading-Accounts/Types/UpdateAccountGroup'
import { UpdateLeverageInstrument } from 'api/Trading-Accounts/Types/UpdateLeverageInstrument'
import { UpdateTradingAccountCountry } from 'api/Trading-Accounts/Types/UpdateTradingAccountCountry'
import { WelcomeAccountDeviceActivityDto } from 'api/Trading-Accounts/Types/WelcomeAccountDeviceActivityDto'
import { WelcomeAccountIpActivityDto } from 'api/Trading-Accounts/Types/WelcomeAccountIpActivityDto'
import { AddUpdateMarketingCampaign } from 'api/Transaction/Types/AddUpdateMarketingCampaign'
import { CurrencyType, WalletDto } from 'api/Wallet/Types/Wallet'
import { PlatformDownloadLinkFormValues } from 'routes/Administration/PlatformDownloadLinks/PlatformDownloadLinkForm'
import { AddRolePermissionFormValues } from 'routes/Administration/Roles/EditRolePermissionForm'
import { RewardDetailsFormValues } from 'routes/Marketing/AddLuckyDrawRewardForm'
import {
  AccountFundsType,
  isAddFunds,
} from 'routes/Records/TradingAccounts/Details/Form/DemoWelcomeAccountDetailsForm'
import { FundsTradingDemoWelcomeAccountFormValues } from 'routes/Records/TradingAccounts/Details/Form/FundsTradingDemoWelcomeAccountForm'

import { AccountType } from '../../api/Trading-Accounts/Types/AccountType'
import { BusinessRuleDto } from '../../api/Trading-Accounts/Types/BusinessRuleDto'
import { ClientSubscriptionDetailBackOfficeDto } from '../../api/Trading-Accounts/Types/ClientSubscriptionDetailBackOfficeDto'
import { CorporateActionDto } from '../../api/Trading-Accounts/Types/CorporateActionDto'
import {
  CountryOverridesDto,
  CountryOverridesResponse,
} from '../../api/Trading-Accounts/Types/CountryOverridesType'
import { CreateCampaignCountryOverride } from '../../api/Trading-Accounts/Types/CreateCampaignCountryOverride'
import {
  AddPlatformConfiguration,
  PlatformConfigurationTypesDto,
} from '../../api/Trading-Accounts/Types/PlatformConfigurationTypesDto'
import { TradingAccountAutoCreateDto } from '../../api/Trading-Accounts/Types/TradingAccountAutoCreateDto'
import { TradingAccountAutoCreateParams } from '../../api/Trading-Accounts/Types/TradingAccountAutoCreateParams'
import { UpdateCampaignCountryOverride } from '../../api/Trading-Accounts/Types/UpdateCampaignCountryOverride'
import { EditCorporateActionFormValues } from '../../routes/Brokerage/Dividends/EditSystemCorporateActionForm'
import { ClientSubscriptionStatusChangeSubmitValues } from '../../routes/Records/Clients/Details/ClientDetailsSubscriptions/ClientSubscriptionChangeStatusForm'
import { ClientSubscriptionPriceOverrideFormValues } from '../../routes/Records/Clients/Details/ClientDetailsSubscriptions/ClientSubscriptionPriceOverrideForm'
import { ApiClient } from './ApiClient'
import { PageQuery, preparePageQueryParams, prepareQueryParams } from './index'
import { createLanguageQueryString } from './queryStringUtils'

export class TradingAccountsApiClient {
  constructor(private apiClient: ApiClient) {}

  getTradingAccounts: (query?: PageQuery) => Promise<PageData<TradingAccountDto[]>> = (query) => {
    return this.apiClient.get(`trading-accounts/trading-accounts?${preparePageQueryParams(query)}`)
  }

  getTradingAccountsWithPlatformOverview: (
    query?: PageQuery
  ) => Promise<PageData<TradingAccountDto[]>> = (query) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/client-area?${preparePageQueryParams(query)}`
    )
  }
  getTradingAccountsQueryString: (
    q: string,
    introducingBrokerId: string
  ) => Promise<PageData<TradingAccountDto[]>> = (q, introducingBrokerId) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts?search=(Name starts ${q}) AND (IB == ${introducingBrokerId})&pageIndex=1&pageSize=100`
    )
  }
  getDisplayCurrencies: () => Promise<{ id: string; name: string }[]> = () => {
    return this.apiClient.get(`/trading-accounts/trading-accounts/platform-types/3/currencies`)
  }
  updateTradingAccount: (id: string, data: UpdateTradingAccount) => Promise<void> = (id, data) => {
    return this.apiClient.put(`trading-accounts/trading-accounts/${id}`, data)
  }
  updateTradingAccountAutomaticClosure: (
    id: string,
    data: Pick<UpdateTradingAccount, 'automaticClosure'>
  ) => Promise<void> = (id, data) => {
    return this.apiClient.put(`trading-accounts/trading-accounts/${id}/automatic-closure`, data)
  }
  createTradingAccount: (data: CreateTradingAccount) => Promise<void> = (data) => {
    return this.apiClient.post(`trading-accounts/trading-accounts`, data)
  }
  getTradingAccountDetails: (id: string) => Promise<TradingAccountDetailDto> = (id) => {
    return this.apiClient.get(`trading-accounts/trading-accounts/${id}`)
  }
  getTradingAccountActivities: (id: string) => Promise<TradingAccountActivityDto[]> = (id) => {
    return this.apiClient.get(`trading-accounts/trading-accounts/${id}/activity`)
  }
  getTradingAccountLimits: (id: string) => Promise<ClientPlatformLimitDto[]> = (id) => {
    return this.apiClient.get(`trading-accounts/clients/${id}/trading-account-limits`)
  }
  updateTradingAccountLimits: (
    id: string,
    data: UpdateClientPlatformLimitDto
  ) => Promise<ClientPlatformLimitDto[]> = (id, data) => {
    return this.apiClient.put(`trading-accounts/clients/${id}/trading-account-limits`, data)
  }
  getWelcomeTradingAccountIpAddressActivity: (
    id: string
  ) => Promise<WelcomeAccountIpActivityDto[]> = (id) => {
    return this.apiClient.get(`trading-accounts/welcome-accounts/${id}/ip-address-activity`)
  }
  getWelcomeTradingAccountDeviceActivity: (
    id: string
  ) => Promise<WelcomeAccountDeviceActivityDto[]> = (id) => {
    return this.apiClient.get(`trading-accounts/welcome-accounts/${id}/device-activity`)
  }
  getTradingAccountActivityDetails: (id: string) => Promise<TradingAccountActivityDetailsDto[]> = (
    id
  ) => {
    return this.apiClient.get(`trading-accounts/trading-accounts/${id}/activity-details`)
  }
  forceCloseTradesForWelcomeAccount: (id: string) => Promise<void> = (id) => {
    return this.apiClient.put(`trading-accounts/welcome-accounts/${id}/force-close-trades`, {})
  }
  getTradingAccountPendingOrders: (id: string) => Promise<TradingAccountPendingOrderDto[]> = (
    id
  ) => {
    return this.apiClient.get(`trading-accounts/trading-accounts/${id}/pending-orders`)
  }
  getTradingAccountOpenPositions: (id: string) => Promise<TradingAccountOpenPositionsDto[]> = (
    id
  ) => {
    return this.apiClient.get(`trading-accounts/trading-accounts/${id}/open-positions`)
  }
  getDemoAccount: (id: string) => Promise<DemoAccountDetails> = (id) => {
    return this.apiClient.get(`trading-accounts/demo-accounts/${id}`)
  }
  updateDemoAccount: (id: string, data: UpdateDemoTradingAccount) => Promise<void> = (id, data) => {
    return this.apiClient.put(`trading-accounts/demo-accounts/${id}`, data)
  }
  depositWithdrawalTradingAccount: (
    tradingAccountType: 'demo-accounts' | 'welcome-accounts',
    type: AccountFundsType,
    data: FundsTradingDemoWelcomeAccountFormValues
  ) => Promise<void> = (tradingAccountType, type, data) => {
    const path = isAddFunds(type) ? 'deposit' : 'withdraw'
    return this.apiClient.post(`trading-accounts/${tradingAccountType}/${path}`, data)
  }
  getDemoTradingAccountStatisticsByTradingAccountId: (
    id: string
  ) => Promise<PlatformStatisticsDto> = (id) => {
    return this.apiClient.get(`trading-accounts/demo-accounts/${id}/platform-statistics`)
  }
  getDemoTradingAccountPlatformTransaction: (
    id: string,
    query?: PageQuery
  ) => Promise<PageData<PlatformTransactionDto[]>> = (id, query) => {
    return this.apiClient.get(
      `trading-accounts/demo-accounts/platform-transactions?tradingAccountId=${id}&${preparePageQueryParams(
        query
      )}`
    )
  }
  getDemoTradingAccountPendingOrders: (id: string) => Promise<TradingAccountPendingOrderDto[]> = (
    id
  ) => {
    return this.apiClient.get(`trading-accounts/demo-accounts/${id}/pending-orders`)
  }
  getDemoTradingAccountOpenPositions: (id: string) => Promise<TradingAccountOpenPositionsDto[]> = (
    id
  ) => {
    return this.apiClient.get(`trading-accounts/demo-accounts/${id}/open-positions`)
  }
  resetDemoTradingAccountPassword: (data: ResetTradingAccountPassword) => Promise<void> = (
    data
  ) => {
    return this.apiClient.put(`trading-accounts/demo-accounts/reset-password`, data)
  }
  getWelcomeAccount: (id: string) => Promise<WelcomeAccountDetails> = (id) => {
    return this.apiClient.get(`trading-accounts/welcome-accounts/${id}`)
  }
  updateWelcomeAccount: (id: string, data: UpdateWelcomeTradingAccount) => Promise<void> = (
    id,
    data
  ) => {
    return this.apiClient.put(`trading-accounts/welcome-accounts/${id}`, data)
  }
  getWelcomeTradingAccountPlatformTransaction: (
    id: string,
    query?: PageQuery
  ) => Promise<PageData<PlatformTransactionDto[]>> = (id, query) => {
    return this.apiClient.get(
      `trading-accounts/welcome-accounts/platform-transactions?tradingAccountId=${id}&${preparePageQueryParams(
        query
      )}`
    )
  }
  getWelcomeTradingAccountStatisticsByTradingAccountId: (
    id: string
  ) => Promise<PlatformStatisticsDto> = (id) => {
    return this.apiClient.get(`trading-accounts/welcome-accounts/${id}/platform-statistics`)
  }
  getWelcomeTradingAccountPendingOrders: (id: string) => Promise<TradingAccountPendingOrderDto[]> =
    (id) => {
      return this.apiClient.get(`trading-accounts/welcome-accounts/${id}/pending-orders`)
    }
  getWelcomeTradingAccountOpenPositions: (id: string) => Promise<TradingAccountOpenPositionsDto[]> =
    (id) => {
      return this.apiClient.get(`trading-accounts/welcome-accounts/${id}/open-positions`)
    }
  resetWelcomeTradingAccountPassword: (data: ResetTradingAccountPassword) => Promise<void> = (
    data
  ) => {
    return this.apiClient.put(`trading-accounts/welcome-accounts/reset-password`, data)
  }
  getTradingAccountCountries: () => Promise<TradingAccountCountryDto[]> = () => {
    return this.apiClient.get(`trading-accounts/configuration/tickmill-company/countries`)
  }
  getTradingAccountPlatformTypesConfiguration: (
    query?: PageQuery
  ) => Promise<PageData<PlatformConfigurationTypesDto[]>> = (query) => {
    return this.apiClient.get(
      `trading-accounts/configuration/tickmill-company-platform-types?${preparePageQueryParams(query)}`
    )
  }
  addTradingAccountPlatformTypeConfiguration: (data: AddPlatformConfiguration) => Promise<void> = (
    data
  ) => {
    return this.apiClient.post(
      `trading-accounts/configuration/tickmill-company-platform-types`,
      data
    )
  }
  updateTradingAccountPlatformTypeConfiguration: (
    tickmillCompanyId: number,
    platformTypeId: number,
    data: AddPlatformConfiguration
  ) => Promise<void> = (tickmillCompanyId, platformTypeId, data) => {
    return this.apiClient.put(
      `trading-accounts/configuration/tickmill-company-platform-types/tickmill-company/${tickmillCompanyId}/platform-type/${platformTypeId}`,
      data
    )
  }
  updateTradingAccountCountry: (
    tickmillCompanyId: number,
    countryId: string,
    data: UpdateTradingAccountCountry
  ) => Promise<CountryPreferenceDto[]> = (tickmillCompanyId, countryId, data) => {
    return this.apiClient.put(
      `trading-accounts/configuration/tickmill-company/${tickmillCompanyId}/country/${countryId}`,
      data
    )
  }

  getTradingAccountAutoCreate: (
    query?: PageQuery
  ) => Promise<PageData<TradingAccountAutoCreateDto[]>> = (query) => {
    return this.apiClient.get(
      `/trading-accounts/trading-accounts/auto-create?${preparePageQueryParams(query)}`
    )
  }

  getTradingAccountAutoCreateById: (id: string) => Promise<TradingAccountAutoCreateDto> = (id) => {
    return this.apiClient.get(`/trading-accounts/trading-accounts/auto-create/${id}`)
  }

  createTradingAccountAutoCreate: (values: TradingAccountAutoCreateParams) => Promise<void> = (
    values
  ) => {
    return this.apiClient.post(`/trading-accounts/trading-accounts/auto-create`, values)
  }

  updateTradingAccountAutoCreateById: (
    id: string,
    values: TradingAccountAutoCreateParams
  ) => Promise<void> = (id, values) => {
    return this.apiClient.put(`/trading-accounts/trading-accounts/auto-create/${id}`, values)
  }

  deleteTradingAccountAutoCreateById: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`/trading-accounts/trading-accounts/auto-create/${id}`)
  }

  getTradingAccountPlatformTransaction: (
    id: string,
    query?: PageQuery
  ) => Promise<PageData<PlatformTransactionDto[]>> = (id, query) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/platform-transactions?tradingAccountId=${id}&${preparePageQueryParams(
        query
      )}`
    )
  }
  getSubscriptions: (
    clientId: string,
    query?: PageQuery
  ) => Promise<ClientSubscriptionDetailBackOfficeDto[]> = (clientId, query) => {
    return this.apiClient.get(
      `trading-accounts/subscriptions/details/clients/${clientId}?${preparePageQueryParams(query)}`
    )
  }
  getSubscriptionsOverrides: () => Promise<ClientSubscriptionDetailBackOfficeDto[]> = () => {
    return this.apiClient.get(`trading-accounts/subscriptions/overrides`)
  }
  deleteSubscriptionOverride: (overrideId: string) => Promise<void> = (overrideId) => {
    return this.apiClient.delete(`trading-accounts/subscriptions/overrides/${overrideId}`)
  }
  addSubscriptionOverride: (values: ClientSubscriptionPriceOverrideFormValues) => Promise<void> = (
    values
  ) => {
    return this.apiClient.post(`trading-accounts/subscriptions/overrides`, values)
  }
  updateSubscriptionOverride: (values: ClientSubscriptionPriceOverrideFormValues) => Promise<void> =
    (values) => {
      return this.apiClient.put(
        `trading-accounts/subscriptions/overrides/${values.subscriptionDetailId}`,
        values
      )
    }
  createSubscriptionRequest: (values: ClientSubscriptionStatusChangeSubmitValues) => Promise<void> =
    (values) => {
      return this.apiClient.post(`trading-accounts/subscriptions/requests`, values)
    }
  getSubscriptionEvents: (clientId: string, subscriptionId: string) => Promise<AuditLog[]> = (
    clientId: string,
    subscriptionId: string
  ) => {
    return this.apiClient.get(
      `trading-accounts/subscriptions/details/clients/${clientId}/subscription-details/${subscriptionId}/events`
    )
  }
  getTradingAccountPlatformStatistics: (clientId: string) => Promise<PlatformStatisticsDto[]> = (
    clientId
  ) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/clients/${clientId}/platform-statistics`
    )
  }
  getTradingAccountStatisticsByTradingAccountId: (id: string) => Promise<PlatformStatisticsDto> = (
    id
  ) => {
    return this.apiClient.get(`trading-accounts/trading-accounts/${id}/platform-statistics`)
  }
  getIntroducingBrokerProfileAccountGroups: (id: string) => Promise<AccountGroup[]> = (id) => {
    return this.apiClient.get(`trading-accounts/introducing-brokers/profiles/${id}/account-groups`)
  }
  addIntroducingBrokerInstruments: (id: string, data: CreateIBProfileInstrument) => Promise<void> =
    (id, data) => {
      return this.apiClient.post(
        `trading-accounts/introducing-brokers/profiles/${id}/instruments`,
        data
      )
    }
  deleteIntroducingBrokerInstrument: (profileId: string, instrumentId: string) => Promise<void> = (
    profileId,
    instrumentId
  ) => {
    return this.apiClient.delete(
      `trading-accounts/introducing-brokers/profiles/${profileId}/instruments/${instrumentId}`
    )
  }
  getTradingAccountLogs: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`trading-accounts/trading-accounts/${id}/events`)
  }
  getDemoAccountEvents: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`trading-accounts/demo-accounts/${id}/events`)
  }
  getWelcomeAccountEvents: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`trading-accounts/welcome-accounts/${id}/events`)
  }
  getTradingAccountRestrictions: () => Promise<IntroducingBrokerProfileAccountType[]> = () => {
    return this.apiClient.get(`trading-accounts/trading-accounts/restriction-types`)
  }
  getInstruments: () => Promise<InstrumentDto<string>[]> = () => {
    return this.apiClient.get(`trading-accounts/instruments`)
  }

  getInstrumentsByTypes: (typeIds?: number | number[]) => Promise<InstrumentDto<string>[]> = (
    typeIds
  ) => {
    if (!typeIds) {
      return this.getInstruments()
    }

    const typeIdsArray = Array.isArray(typeIds) ? typeIds : [typeIds]

    const queryParams = typeIdsArray.map((id) => `typeId=${id}`).join('&')

    return this.apiClient.get(`trading-accounts/instruments?${queryParams}`)
  }

  getLeverages: ({
    platformId,
    serverId,
  }: {
    platformId: number
    serverId: string
  }) => Promise<LeverageInstrumentDto[]> = ({
    platformId,
    serverId,
  }: {
    platformId: number
    serverId: string
  }) => {
    return this.apiClient.get(
      `trading-accounts/instruments/platforms/${platformId}/servers/${serverId}`
    )
  }

  updateLeverageInstrument: ({
    platformId,
    serverId,
    data,
  }: {
    platformId: number
    serverId: string
    data: UpdateLeverageInstrument[]
  }) => Promise<LeverageInstrumentDto[]> = ({
    platformId,
    serverId,
    data,
  }: {
    platformId: number
    serverId: string
    data: UpdateLeverageInstrument[]
  }) => {
    return this.apiClient.put(
      `trading-accounts/instruments/platforms/${platformId}/servers/${serverId}`,
      data
    )
  }

  uploadLeverageFile: (platformId: number, serverId: string, data: FormData) => Promise<void> = (
    platformId: number,
    serverId: string,
    data: FormData
  ) => {
    return this.apiClient.upload(
      'PUT',
      `trading-accounts/instruments/platforms/${platformId}/servers/${serverId}/csv`,
      data
    )
  }

  addInstrument: (data: AddUpdateInstrument<string>) => Promise<InstrumentDto[]> = (data) => {
    return this.apiClient.post(`trading-accounts/instruments`, data)
  }
  updateInstrument: (data: AddUpdateInstrument<string>) => Promise<InstrumentDto[]> = (data) => {
    return this.apiClient.put(`trading-accounts/instruments/${data.id}`, data)
  }
  deleteInstrument: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`trading-accounts/instruments/${id}`)
  }
  getTradingAccountInstrumentTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/instruments/instrument-types`)
  }
  getTradingAccountServerType: (platformTypeId?: number) => Promise<ServerType[]> = (
    platformTypeId
  ) => {
    if (!platformTypeId) return this.apiClient.get('trading-accounts/trading-accounts/servers')
    return this.apiClient.get(
      `trading-accounts/trading-accounts/servers?${new URLSearchParams({
        platformTypeId: platformTypeId.toString(),
      })}`
    )
  }
  getTradingAccountLeverageType: () => Promise<LeverageType[]> = () => {
    return this.apiClient.get(`trading-accounts/trading-accounts/leverage-types`)
  }
  getTradingAccountLeverageTypesForPlatforms: (
    clientId: string,
    platformTypeId: string | number
  ) => Promise<LeverageType[]> = (clientId, platformTypeId) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/clients/${clientId}/leverage-types-for-platform/${platformTypeId}`
    )
  }
  getTradingAccountClientPlatformType: (
    clientId: string,
    tickmillProductId: number
  ) => Promise<ClientPlatformType[]> = (clientId, tickmillProductId) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/clients/${clientId}/products/${tickmillProductId}/platform-types`
    )
  }
  getTradingAccountPlatformType: () => Promise<PlatformTypeDto[]> = () => {
    return this.apiClient.get(`trading-accounts/trading-accounts/platform-types`)
  }
  getTradingAccountBookType: () => Promise<BookType[]> = () => {
    return this.apiClient.get(`trading-accounts/trading-accounts/book-types`)
  }
  getTradingAccountStatuses: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/trading-accounts/trading-account-statuses`)
  }
  getTradingViewPlans: () => Promise<TradingViewPlanDto[]> = () => {
    return this.apiClient.get(`trading-accounts/trading-accounts/trading-view-plans`)
  }
  getTradingViewPlanExpirationDays: () => Promise<TradingViewPlanExpirationDaysDto[]> = () => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/trading-view-plans-expiration-days`
    )
  }
  getTradingAccountType: (query?: PageQuery) => Promise<AccountType[]> = (query) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/accounts-types?${preparePageQueryParams(query)}`
    )
  }
  getExtendedTradingAccountType: ({
    platformTypeId,
    currencyId,
    accountGroupTypeId,
  }: {
    platformTypeId: number
    currencyId: string
    accountGroupTypeId: number
  }) => Promise<AccountType[]> = ({ platformTypeId, currencyId, accountGroupTypeId }) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/platform-types/${platformTypeId}/currencies/${currencyId}/account-group-types/${accountGroupTypeId}/account-types`
    )
  }
  getTradingAccountGroupType: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/trading-accounts/account-group-types`)
  }
  getTradingAccountClassificationType: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/trading-accounts/classification-types`)
  }
  getTradingAccountGroupsAll: (query?: PageQuery) => Promise<AccountGroupDto[]> = (query) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/account-groups/all?${new URLSearchParams(query)}`
    )
  }
  getTradingAccountGroupsForTradingAccount: (id: string) => Promise<AccountGroupBasicDto[]> = (
    id
  ) => {
    return this.apiClient.get(`trading-accounts/trading-accounts/${id}/account-groups`)
  }
  getAccountGroupsByDemoAccount: (id: string) => Promise<AccountGroupBasicDto[]> = (id) => {
    return this.apiClient.get(`trading-accounts/demo-accounts/${id}/account-groups`)
  }
  getAccountGroupsByWelcomeAccount: (id: string) => Promise<AccountGroupBasicDto[]> = (id) => {
    return this.apiClient.get(`trading-accounts/demo-accounts/${id}/account-groups`)
  }
  getAccountGroups: (query?: PageQuery) => Promise<PageData<AccountGroupDto[]>> = (query) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/account-groups?${preparePageQueryParams(query)}`
    )
  }
  getAvailableAccountGroups: (
    id: string,
    query?: PageQuery
  ) => Promise<PageData<AccountGroupDto[]>> = (id, query) => {
    return this.apiClient.get(
      `trading-accounts/introducing-brokers/profiles/${id}/available-account-groups?${preparePageQueryParams(
        query
      )}`
    )
  }
  getAccountGroup: (id: string) => Promise<AccountGroupDto> = (id) => {
    return this.apiClient.get(`trading-accounts/trading-accounts/account-groups/${id}`)
  }
  updateAccountGroup: (id: string, data: UpdateAccountGroup) => Promise<AccountGroupDto> = (
    id,
    data
  ) => {
    return this.apiClient.put(`trading-accounts/trading-accounts/account-groups/${id}`, data)
  }
  getTradingAccountByWalletId: (id: string) => Promise<PageData<TradingAccountDto[]>> = (id) => {
    const query = { pageSize: 100, pageIndex: 1 }
    return this.apiClient.get(
      `trading-accounts/trading-accounts/wallets/${id}?${preparePageQueryParams(query)}`
    )
  }
  getAccountGroupByWalletPlatformTradingAccountTypeAndIntroducingBrokerId: (
    query?: PageQuery
  ) => Promise<AccountGroupBasicDto[]> = (query) => {
    delete query?.pageIndex
    delete query?.pageSize
    return this.apiClient.get(
      `trading-accounts/trading-accounts/account-groups/list?${preparePageQueryParams(query)}`
    )
  }
  getTradingAccountByClientId: (
    id: string,
    query?: PageQuery
  ) => Promise<PageData<TradingAccountDto[]>> = (id, query) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/clients/${id}?${preparePageQueryParams(query)}`
    )
  }
  getWalletWithTradingAccountByClientId: (id: string) => Promise<WalletDto[]> = (id) => {
    return this.apiClient.get(`trading-accounts/trading-accounts/clients/${id}/wallets`)
  }
  getNegativeEquityByServerIdAndPlatformType: (
    query: PageQuery
  ) => Promise<PageData<TradingAccountDto[]>> = (query) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/negative-equity?${preparePageQueryParams(query)}`
    )
  }
  resetTradingAccountPassword: (data: ResetTradingAccountPassword) => Promise<void> = (data) => {
    return this.apiClient.put(`trading-accounts/trading-accounts/reset-password`, data)
  }
  getTradingAccountTradedLots: (
    id: string,
    type: 'wallets' | 'clients',
    query?: PageQuery
  ) => Promise<TradingAccountLotsProfitStatisticDto[]> = (id, type, query) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/${type}/${id}/total-traded-lots?${preparePageQueryParams(
        query
      )}`
    )
  }
  getMarketingCampaigns: (query?: PageQuery) => Promise<PageData<MarketingCampaignDto[]>> = (
    query
  ) => {
    return this.apiClient.get(`trading-accounts/campaigns?${preparePageQueryParams(query)}`)
  }

  getEnabledMarketingCampaigns: (query?: PageQuery) => Promise<NameDto[]> = (query) => {
    return this.apiClient.get(
      `trading-accounts/campaigns/lucky-draw/enabled?${preparePageQueryParams(query)}`
    )
  }
  getMarketingCampaign: (id: string) => Promise<MarketingCampaignDetailDto> = (id) => {
    return this.apiClient.get(`trading-accounts/campaigns/${id}`)
  }
  updateMarketingCampaign: (
    campaignId: string,
    data: AddUpdateMarketingCampaign
  ) => Promise<MarketingCampaignDetailDto> = (campaignId, data) => {
    return this.apiClient.put(`trading-accounts/campaigns/${campaignId}`, data)
  }
  addMarketingCampaign: (data: AddUpdateMarketingCampaign) => Promise<MarketingCampaignDetailDto> =
    (data) => {
      return this.apiClient.post(`trading-accounts/campaigns`, data)
    }
  addMarketingCampaignCountryOverride: (
    campaignId: string,
    data: CreateCampaignCountryOverride
  ) => Promise<void> = (campaignId, data) => {
    return this.apiClient.post(`trading-accounts/campaigns/${campaignId}/country-overrides`, data)
  }
  editMarketingCampaignCountryOverride: (
    campaignId: string,
    countryId: string,
    data: UpdateCampaignCountryOverride
  ) => Promise<void> = (campaignId, countryId, data) => {
    return this.apiClient.put(
      `trading-accounts/campaigns/${campaignId}/country-overrides/${countryId}`,
      data
    )
  }
  deleteMarketingCampaignCountryOverride: (
    campaignId: string,
    countryOverrideId: string
  ) => Promise<void> = (campaignId, countryOverrideId) => {
    return this.apiClient.delete(
      `trading-accounts/campaigns/${campaignId}/country-overrides/${countryOverrideId}`
    )
  }
  getMarketingCampaignEvents: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`trading-accounts/campaigns/${id}/events`)
  }

  getCurrencies: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/trading-accounts/currencies`)
  }

  getCurrenciesByPlatformType: (
    platformTypeId: PlatformTypeId
  ) => Promise<NameDto<CurrencyType>[]> = (platformTypeId) => {
    return this.apiClient.get<NameDto<CurrencyType>[]>(
      `/trading-accounts/trading-accounts/platform-types/${platformTypeId}/currencies`
    )
  }
  getCampaignTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/campaigns/campaign-types`)
  }
  getCampaignCalculationTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get('trading-accounts/campaigns/calculation-types')
  }
  getCampaignCalculationTypesByCampaignTypeId: (campaignTypeId: number) => Promise<NameDto[]> = (
    campaignTypeId: number
  ) => {
    return this.apiClient.get(
      `trading-accounts/campaigns/campaign-types/${campaignTypeId}/calculation-types`
    )
  }
  getBusinessRuleTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/trading-accounts/business-rule-types`)
  }
  getBusinessRuleTypesByRuleTypeId: (businessRuleTypeId?: number) => Promise<BusinessRuleDto[]> = (
    businessRuleTypeId?: number
  ) => {
    // Construct an object with all potential parameters
    const queryParams = {
      businessRuleTypeId: businessRuleTypeId?.toString(),
    }

    // Use URLSearchParams to construct the query string from filtered parameters
    const params = prepareQueryParams(queryParams)

    return this.apiClient.get(`trading-accounts/trading-accounts/business-rules?${params}`)
  }
  getCampaignStatuses: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/campaigns/campaign-statuses`)
  }
  getIntervalTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/campaigns/interval-types`)
  }
  getMarketingCampaignResults: (
    campaignId: string,
    campaignTypeId: MarketingCampaignType,
    query?: PageQuery
  ) => Promise<PageData<InternalResultsIBResultsDto[]>> = (campaignId, campaignTypeId, query) => {
    const type: 'client-rebate' | 'client-contest' | 'ib-contest' = getCampaignName(campaignTypeId)

    return this.apiClient.get(
      `trading-accounts/campaigns/${campaignId}/${type}-results/internal?${preparePageQueryParams(
        query
      )}`
    )
  }
  releaseMarketingCampaign: (campaignId: string) => Promise<void> = (campaignId) => {
    return this.apiClient.post(`trading-accounts/campaigns/${campaignId}/release`, {})
  }
  getTradingAccountsSecuredPropertiesLabels: () => Promise<SecuredPropertiesLabels[]> = () => {
    return this.apiClient.get(`trading-accounts/secured-properties/labels`)
  }
  getRoleTradingAccountsSecuredPropertiesLabels: (
    query?: PageQuery
  ) => Promise<RoleSecuredProperties[]> = (query) => {
    return this.apiClient.get(
      `trading-accounts/secured-properties?${preparePageQueryParams(query)}`
    )
  }
  setRoleTradingAccountsSecuredProperties: (
    data: AddRolePermissionFormValues
  ) => Promise<SecuredPropertiesLabels[]> = (data) => {
    return this.apiClient.post(`trading-accounts/secured-properties/set`, data)
  }
  deleteRoleTradingAccountsSecuredProperties: (
    data: Omit<AddRolePermissionFormValues, 'securedProperties'> & {
      name: string
    }
  ) => Promise<SecuredPropertiesLabels[]> = ({ aggregateType, role, name }) => {
    return this.apiClient.delete(
      `trading-accounts/secured-properties/${aggregateType}/${role}/${name}`
    )
  }
  getCampaignsForDepositClient: (walletId: string) => Promise<PageData<TradingAccountDto[]>> = (
    walletId
  ) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/client-area?Search=(Wallet == ${walletId}) AND (Campaign isnotempty 1)&PageSize=100`
    )
  }
  getPlatformTransactionTypes: (id: number) => Promise<PlatformTransactionTypeDto[]> = (id) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/platform-types/${id}/platform-transaction-types`
    )
  }

  getPlatformTypesCompanyById: (tickmillCompanyId: number) => Promise<NameDto[]> = (
    tickmillCompanyId
  ) => {
    return this.apiClient.get(
      `trading-accounts/trading-accounts/platform-types/tickmill-companies/${tickmillCompanyId}`
    )
  }

  getTradingAccountSubscriptionDetails: (
    query?: PageQuery
  ) => Promise<PageData<SubscriptionDetailDetailsDto[]>> = (query) => {
    return this.apiClient.get(
      `trading-accounts/subscriptions/details?${preparePageQueryParams(query)}`
    )
  }

  getTradingAccountSubscriptionById: (subscriptionId: string) => Promise<SubscriptionDetailsDto> = (
    subscriptionId
  ) => {
    return this.apiClient.get(`trading-accounts/subscriptions/${subscriptionId}`)
  }

  updateTradingAccountSubscriptionById: (
    subscriptionId: string,
    values: EditSubscription
  ) => Promise<void> = (subscriptionId, values) => {
    return this.apiClient.put(`trading-accounts/subscriptions/${subscriptionId}`, values)
  }

  deleteTradingAccountSubscriptionById: (subscriptionId: string) => Promise<void> = (
    subscriptionId
  ) => {
    return this.apiClient.delete(`trading-accounts/subscriptions/details/${subscriptionId}`)
  }

  createTradingAccountSubscription: (
    values: CreateSubscriptionDetail
  ) => Promise<EditSubscriptionDetail> = (values) => {
    return this.apiClient.post('trading-accounts/subscriptions/details', values)
  }

  updateTradingAccountSubscription: (
    subscriptionId: string,
    values: EditSubscriptionDetail
  ) => Promise<SubscriptionDetailDto> = (subscriptionId, values) => {
    return this.apiClient.put(`trading-accounts/subscriptions/details/${subscriptionId}`, values)
  }

  deleteTradingAccountSubscriptionPlatformById: (
    platformTypeId: number,
    subscriptionId: string
  ) => Promise<void> = (platformTypeId, subscriptionId) => {
    return this.apiClient.delete(
      `trading-accounts/subscriptions/platforms/${platformTypeId}?subscriptionId=${subscriptionId}`
    )
  }

  createTradingAccountSubscriptionPlatform: (values: CreateSubscriptionPlatform) => Promise<void> =
    (values) => {
      return this.apiClient.post('trading-accounts/subscriptions/platforms', values)
    }

  getTradingAccountSubscriptionClassificationTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`/trading-accounts/subscriptions/classification-types`)
  }

  getTradingAccountSubscriptionDetailTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`/trading-accounts/subscriptions/details/types`)
  }

  getTradingAccountSubscriptionGroups: () => Promise<PageData<SubscriptionGroupDto[]>> = () => {
    return this.apiClient.get(`/trading-accounts/subscriptions/groups`)
  }

  getTradingAccountSubscriptionAllGroups: () => Promise<SubscriptionGroupDto[]> = async () => {
    const result: PageData<SubscriptionGroupDto[]> = await this.apiClient.get(
      `/trading-accounts/subscriptions/groups?pageSize=100`
    )
    return result.items || []
  }

  getTradingAccountSubscriptionBillingPeriods: () => Promise<PageData<NameDto[]>> = () => {
    return this.apiClient.get(`/trading-accounts/subscriptions/billing-periods`)
  }

  getDividends: (query?: PageQuery) => Promise<PageData<DividendPaymentDataDto[]>> = (query) => {
    return this.apiClient.get(`/trading-accounts/dividends/browse?${preparePageQueryParams(query)}`)
  }

  deleteDividend: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`/trading-accounts/dividends/${id}`)
  }

  // createDividend: (data: CreateDividendPaymentDataDto) => Promise<PageData<DividendPaymentDataDto>> = (data) => {
  //     return this.apiClient.post('/trading-accounts/dividends', data)
  // }

  updateDividend: (id: string, data: UpdateDividendPaymentDataDto) => Promise<void> = (
    id,
    data
  ) => {
    return this.apiClient.put(`/trading-accounts/dividends/${id}`, data)
  }

  updateCorporateAction: (id: string, data: EditCorporateActionFormValues) => Promise<void> = (
    id,
    data
  ) => {
    return this.apiClient.put(`/trading-accounts/corporate-actions/${id}`, {
      excluded: data.isExcluded,
    })
  }

  getDividendSubTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get('/trading-accounts/dividends/sub-types')
  }
  getCorporateActionTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get('/trading-accounts/corporate-actions/types')
  }

  uploadDividendPreview: (formData: FormData) => Promise<UploadDividendPaymentDataDto> = (data) => {
    return this.apiClient.upload('POST', '/trading-accounts/dividends/upload/preview', data)
  }

  uploadLeveragePreview: (formData: FormData) => Promise<UploadLeverageInstrumentDto[]> = (
    data
  ) => {
    return this.apiClient.upload('POST', '/trading-accounts/instruments/upload/preview', data)
  }

  uploadDividendFile: (formData: FormData) => Promise<void> = (data) => {
    return this.apiClient.upload('POST', '/trading-accounts/dividends/upload', data)
  }

  getCorporateActions: (query?: PageQuery) => Promise<PageData<CorporateActionDto[]>> = (query) => {
    return this.apiClient.get(
      `/trading-accounts/corporate-actions?${preparePageQueryParams(query)}`
    )
  }

  getRewardCategories: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`/trading-accounts/rewards/reward-categories`)
  }

  getRewardTrackingMetrics: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`/trading-accounts/rewards/tracking-metrics`)
  }

  getRewardProgramTierConditionsLogic: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`/trading-accounts/rewards/reward-program-tier-conditions-logic`)
  }

  getRewardProgramTierLogicalOperators: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`/trading-accounts/rewards/reward-program-tier-logical-operators`)
  }

  getRewardProgramResetCadence: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`/trading-accounts/rewards/reset-cadences`)
  }

  getRewardProgramStatuses: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/rewards/reward-statuses`)
  }

  getRewards: (query?: PageQuery) => Promise<PageData<RewardsHubDto[]>> = (query) => {
    return this.apiClient.get(`/trading-accounts/rewards?${preparePageQueryParams(query)}`)
  }

  getRewardsEvent: () => Promise<AuditLog[]> = () => {
    return this.apiClient.get('/trading-accounts/rewards/events')
  }

  getRewardPrograms: (query?: PageQuery) => Promise<PageData<RewardProgramDto[]>> = (query) => {
    return this.apiClient.get(`/trading-accounts/rewards/programs?${preparePageQueryParams(query)}`)
  }

  getRewardProgramEvent: (rewardProgramId: string) => Promise<AuditLog[]> = (rewardProgramId) => {
    return this.apiClient.get(`/trading-accounts/rewards/programs/${rewardProgramId}/events`)
  }

  getRewardProgramDetails: (id: string) => Promise<RewardProgramDetailsDto> = (id) => {
    return this.apiClient.get(`/trading-accounts/rewards/programs/${id}`)
  }

  updateRewardProgramDetails: (id: string, values: RewardProgramDetailsUpdateDto) => Promise<void> =
    (id, values) => {
      return this.apiClient.put(`trading-accounts/rewards/program/${id}`, values)
    }

  addReward: (data: RewardsHubCreateDto) => Promise<void> = (data) => {
    return this.apiClient.post('/trading-accounts/rewards', data)
  }

  updateReward: (id: string, values: Partial<RewardsHubCreateDto>) => Promise<void> = (
    id,
    values
  ) => {
    return this.apiClient.put(`/trading-accounts/rewards/${id}`, values)
  }

  addRewardProgram: (data: RewardProgramDetailsUpdateDto) => Promise<void> = (data) => {
    return this.apiClient.post('/trading-accounts/rewards/program', data)
  }

  getMarketingCampaignRewards: (
    campaignId: string,
    languageId?: string
  ) => Promise<LuckyDrawRewardsDto[]> = (campaignId, languageId?) => {
    return this.apiClient.get(
      `trading-accounts/campaigns/${campaignId}/lucky-draw-rewards/${createLanguageQueryString(languageId)}`
    )
  }

  addLuckyDrawReward: (campaignId: string, data: RewardDetailsFormValues) => Promise<void> = (
    campaignId,
    data
  ) => {
    return this.apiClient.post(`trading-accounts/campaigns/${campaignId}/lucky-draw-rewards/`, data)
  }

  getTradingAccountSubscriptionUnsubscribeRequests: (
    query?: PageQuery
  ) => Promise<PageData<UnsubscribeRequestDto[]>> = (query) => {
    return this.apiClient.get(
      `trading-accounts/subscriptions/subscription-request-cancellations?${preparePageQueryParams(
        query
      )}`
    )
  }
  updateTradingAccountSubscriptionUnsubscribeRequest: (
    id: string,
    values: EditUnsubscribeRequestDto
  ) => Promise<void> = (id, values) => {
    return this.apiClient.put(
      `trading-accounts/subscriptions/subscription-request-cancellations/${id}`,
      values
    )
  }

  approveTradingAccountSubscriptionUnsubscribeRequests: (
    values: EditUnsubscribeRequestsDto
  ) => Promise<UnsubscribeRequestDto> = (values) => {
    return this.apiClient.put(
      `trading-accounts/subscriptions/subscription-request-cancellations/approve`,
      values
    )
  }

  rejectTradingAccountSubscriptionUnsubscribeRequests: (
    values: EditUnsubscribeRequestsDto
  ) => Promise<UnsubscribeRequestDto> = (values) => {
    return this.apiClient.put(
      `trading-accounts/subscriptions/subscription-request-cancellations/reject`,
      values
    )
  }
  deleteLuckyDrawReward: (campaignId: string, rewardId: string) => Promise<void> = (
    campaignId,
    rewardId
  ) => {
    return this.apiClient.delete(
      `trading-accounts/campaigns/${campaignId}/lucky-draw-rewards/${rewardId}`
    )
  }

  updateLuckyDrawReward: (campaignId: string, data: RewardDetailsFormValues) => Promise<void> = (
    campaignId,
    data
  ) => {
    return this.apiClient.put(
      `trading-accounts/campaigns/${campaignId}/lucky-draw-rewards/${data.id}`,
      data
    )
  }

  getLuckyDrawRewardTypes: (languageId?: string) => Promise<LuckyDrawRewardTypeDto[]> = (
    languageId?
  ) => {
    return this.apiClient.get(
      `trading-accounts/campaigns/lucky-draw-reward-types${createLanguageQueryString(languageId)}`
    )
  }

  getLuckyDrawActivityTypes: (languageId?: string) => Promise<LuckyDrawActivityTypeDto[]> = (
    languageId?
  ) => {
    return this.apiClient.get(
      `trading-accounts/campaigns/lucky-draw-activity-types${createLanguageQueryString(languageId)}`
    )
  }

  getMarginBonusOptionsWithdrawRules: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/campaigns/margin-bonus-options-withdraw-rules`)
  }

  getMarginBonusLabels: () => Promise<MarginBonusLabel[]> = () => {
    return this.apiClient.get(`trading-accounts/campaigns/margin-bonus-labels`)
  }

  getMarginBonusAvailabilityPeriods: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/campaigns/margin-availability-periods`)
  }

  getMarginBonusCountdownTriggers: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/campaigns/margin-bonus-countdown-triggers`)
  }

  getMarginBonusExcludeTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`trading-accounts/campaigns/margin-bonus-exclude-types`)
  }

  getLuckyDrawResults: (
    campaignId: string,
    query?: PageQuery
  ) => Promise<PageData<LuckyDrawResultDto[]>> = (campaignId, query) => {
    return this.apiClient.get(
      `trading-accounts/campaigns/${campaignId}/lucky-draw-results?${preparePageQueryParams(query)}`
    )
  }

  getLuckyDrawResultById: (id: string) => Promise<LuckyDrawResultDto> = (id) => {
    return this.apiClient.get(`trading-accounts/campaigns/lucky-draw-results/${id}`)
  }

  getPlatformDownloadLinks: (query?: PageQuery) => Promise<PageData<PlatformDownloadLinkDto[]>> = (
    query?: PageQuery
  ) => {
    return this.apiClient.get(
      `trading-accounts/platform-download-links?${preparePageQueryParams(query)}`
    )
  }

  getTradingAccountOperatingSystems: () => Promise<NameDto[]> = () => {
    return this.apiClient.get('/trading-accounts/platform-download-links/operating-systems')
  }

  createPlatformDownloadLink: (data: PlatformDownloadLinkFormValues) => Promise<void> = (data) => {
    return this.apiClient.post('/trading-accounts/platform-download-links', data)
  }

  updatePlatformDownloadLink: (id: string, data: PlatformDownloadLinkFormValues) => Promise<void> =
    (id, data) => {
      return this.apiClient.put(`/trading-accounts/platform-download-links/${id}`, data)
    }

  getPlatformDownloadLinkEvents: () => Promise<AuditLog[]> = () => {
    return this.apiClient.get('/trading-accounts/platform-download-links/events')
  }

  getCountryOverrides: (query?: PageQuery) => Promise<CountryOverridesResponse> = (query) => {
    return this.apiClient.get(
      `/trading-accounts/configuration/tickmill-company-platform-types-country-overrides?${preparePageQueryParams(query)}`
    )
  }

  createCountryOverrides: (data: CountryOverridesDto) => Promise<void> = (data) => {
    return this.apiClient.post(
      '/trading-accounts/configuration/tickmill-company-platform-types-country-overrides',
      data
    )
  }
  updateCountryOverrides: (data: CountryOverridesDto) => Promise<void> = ({
    TradingAllowed,
    CountryId,
    PlatformTypeId,
    TickmillCompanyId,
  }) => {
    return this.apiClient.put(
      `/trading-accounts/configuration/tickmill-company-platform-types-country-overrides/tickmill-company/${TickmillCompanyId}/platform-type/${PlatformTypeId}/country/${CountryId}`,
      { TradingAllowed }
    )
  }
  deleteCountryOverrides: (data: CountryOverridesDto) => Promise<void> = ({
    TradingAllowed,
    CountryId,
    PlatformTypeId,
    TickmillCompanyId,
  }) => {
    return this.apiClient.delete(
      `/trading-accounts/configuration/tickmill-company-platform-types-country-overrides/tickmill-company/${TickmillCompanyId}/platform-type/${PlatformTypeId}/country/${CountryId}`,
      { data: { TradingAllowed } }
    )
  }

  getInstrumentLeverageAdjustmentEvents = async (instrumentId: string): Promise<AuditLog[]> => {
    return this.apiClient.get(
      `trading-accounts/instrument-leverage-adjustment-histories/${instrumentId}/events`
    )
  }

  getMarginBonusResults: (
    campaignId: string,
    query?: PageQuery
  ) => Promise<PageData<MarginBonusResultDto[]>> = (campaignId, query) => {
    return this.apiClient.get(
      `trading-accounts/campaigns/${campaignId}/margin-bonus-results?${preparePageQueryParams(query)}`
    )
  }
  getMarginBonusResultStatuses: () => Promise<NameDto[]> = () => {
    return this.apiClient.get('trading-accounts/campaigns/margin-bonus-result-statuses')
  }

  getSwapFreeOptions: (query: PageQuery) => Promise<PageData<SwapFreeOptionDto[]>> = (query) => {
    return this.apiClient.get(`trading-accounts/swap-free/options?${preparePageQueryParams(query)}`)
  }

  createSwapFreeOption: (data: AddEditSwapFreeOptionFormValues) => Promise<void> = (data) => {
    return this.apiClient.post('trading-accounts/swap-free/option', data)
  }
  updateSwapFreeOption: (data: AddEditSwapFreeOptionFormValues) => Promise<void> = (data) => {
    return this.apiClient.put('trading-accounts/swap-free/option', data)
  }
  runDividendPaymentDataToAdjustments: (data: RunDividendAdjustmentsDto) => Promise<void> = (
    data
  ) => {
    return this.apiClient.post(
      '/trading-accounts/management/run-dividend-payment-data-to-adjustments',
      data
    )
  }
  updateTradingAccountArchivingExclusion: (
    tradingAccountId: string,
    data: UpdateTradingAccountArchivingExclusionDto
  ) => Promise<void> = (tradingAccountId, data) => {
    return this.apiClient.put(
      `trading-accounts/trading-accounts/${tradingAccountId}/archiving-exclusion`,
      data
    )
  }
  archiveTradingAccountsByNames: (
    data: ArchiveTradingAccountsByNamesDto
  ) => Promise<ArchiveTradingAccountsResponseDto> = (data) => {
    return this.apiClient.post(
      'trading-accounts/management/archive-trading-accounts-by-names',
      data
    )
  }
}
